const constantsProgressBar = {
	DocumentStep: "Documento",
	KBAStep: "Pergunta de segurança",
	"KBAStep-1": "Pergunta de segurança",
	"KBAStep-2": "Pergunta de segurança",
	FullNameStep: "Nome completo",
	BirthDateStep: "Data de nascimento",
	EmailStep: "E-mail",
	PhoneStep: "Celular",
	MFAVerificationCodeStep: "Celular",
	PasswordStep: "Senha",
	CompleteSignUpNCADStep: "Dados complementares",
} as { [key: string]: string };

export default constantsProgressBar;
